import React from "react";
import LegalContentPage from "./legal_content_page";
import type { ContentItem } from "./legal_content_page";

const returnPolicyText: ContentItem[] = [
  {
    type: "heading",
    text: "Version 1.0",
  },
  {
    type: "paragraph",
    text: "We're finalizing our Return Policy. The full policy will be published here shortly — please check back soon.",
  },
];

const ReturnPolicyPage: React.FC = () => {
  return <LegalContentPage title="Return Policy" content={returnPolicyText} />;
};

export default ReturnPolicyPage;
